module.exports = __webpack_public_path__ + "img/refresh.066285f2.png";